export const EDIT_SETTINGS_SUCCESS_MSG = 'Settings successfully saved!';
export const ADD_LOCATION_SUCCESS_MSG = 'Branch location successfully created!';
export const DUPLICATE_LOCATION_SUCCESS_MSG = 'Branch location successfully duplicated!';
